import * as recruitJsonApi from './recruitJson';
import * as settingsApi from './settings';

export default {
  recruitJsonGetTemplates: recruitJsonApi.recruitJsonGetTemplates,
  recruitJsonMakeDefault: recruitJsonApi.recruitJsonMakeDefault,
  recruitJsonDuplicate: recruitJsonApi.recruitJsonDuplicate,
  recruitJsonDeleteTemplate: recruitJsonApi.recruitJsonDeleteTemplate,
  recruitJsonCreate: recruitJsonApi.recruitJsonCreate,
  recruitJsonMakeHidden: recruitJsonApi.recruitJsonMakeHidden,

  settingsGetNotifications: settingsApi.getNotificationsSettings,
  settingsUpdateNotifications: settingsApi.updateNotificationsSettings,
  settingsGetTeam: settingsApi.getTeamSettings,
  settingsUpdateTeam: settingsApi.updateTeamSettings,
  settingsDeleteTeam: settingsApi.deleteTeamSettings,
  settingsGetUserRoles: settingsApi.getUserRolesSettings,
  settingsUpdateUserRoles: settingsApi.updateUserRolesSettings,
  settingsGetCustomFields: settingsApi.getCustomFieldsSettings,
  settingsUpdateCustomFields: settingsApi.updateCustomFieldsSettings,
  settingsGetAllTemplates: settingsApi.getAllTemplates,
};
